export function getHostColorScheme(): string {
  return getComputedStyle(document.documentElement).colorScheme || 'normal';
}

export function toDocumentColorScheme(hostScheme: string | null | undefined): string {
  return hostScheme && hostScheme !== 'normal' ? hostScheme : '';
}

export function applyHostColorSchemeToDocument(hostScheme: string | null | undefined): void {
  document.documentElement.style.colorScheme = toDocumentColorScheme(hostScheme);
}

export function applyHostColorSchemeToIframeElement(
  iframe: HTMLIFrameElement | null,
  hostScheme: string
): void {
  if (!iframe) return;
  iframe.style.setProperty('color-scheme', toDocumentColorScheme(hostScheme));
}

export function startHostColorSchemeObserver(onChange: (scheme: string) => void): () => void {
  let lastScheme = getHostColorScheme();

  const sync = () => {
    const nextScheme = getHostColorScheme();
    if (nextScheme === lastScheme) return;
    lastScheme = nextScheme;
    onChange(nextScheme);
  };

  const observer = new MutationObserver(sync);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class', 'style', 'data-theme']
  });

  const mediaQuery =
    typeof window.matchMedia === 'function'
      ? window.matchMedia('(prefers-color-scheme: dark)')
      : null;
  mediaQuery?.addEventListener('change', sync);

  return () => {
    observer.disconnect();
    mediaQuery?.removeEventListener('change', sync);
  };
}
